import * as React from 'react';

import { useAskNeedlDispatchContext } from '@/features/ChatBotV2/context';
import { ASK_NEEDL_ACTIONS } from '@/features/ChatBotV2/hooks/useAskNeedlState';
import type { AttachmentType } from '@/features/ChatBotV2/types';
import type { BoardFileType } from '@/features/CustomFeedV2/common';
import { usePollDocumentsFeed } from '@/hooks/query/usePollDocumentsFeed';

export const usePollAttachmentsStatus = (
  attachments: AttachmentType[],
  feedId?: string
) => {
  const dispatch = useAskNeedlDispatchContext();
  const callback = React.useCallback(
    (documents: BoardFileType[]) => {
      for (const document of documents) {
        dispatch({
          type: ASK_NEEDL_ACTIONS.SET_ATTACHMENTS_STATUS,
          payload: {
            attachmentIds: [document.id],
            status:
              document.status === 'COMPLETED'
                ? 'COMPLETED'
                : document.status === 'FAILED'
                ? 'PROCESSING_ERROR'
                : 'PROCESSING',
          },
        });
      }
    },
    [dispatch]
  );

  const { startPolling, stopPolling } = usePollDocumentsFeed(
    feedId as string,
    callback
  );

  const areAttachmentsProcessing = React.useMemo(() => {
    return attachments.some((attachment) => attachment.status === 'PROCESSING');
  }, [attachments]);

  React.useEffect(() => {
    if (areAttachmentsProcessing && feedId) {
      startPolling();
    } else {
      stopPolling();
    }
  }, [areAttachmentsProcessing, feedId, startPolling, stopPolling]);

  return null;
};
